'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendConsentToCommunicate = sendConsentToCommunicate;

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _wrappedPortalIdParser = require('../../utils/wrappedPortalIdParser');

var _wrappedPortalIdParser2 = _interopRequireDefault(_wrappedPortalIdParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ENDPOINT = 'livechat/v1/privacy/consentToCommunicate';

function sendConsentToCommunicate(_ref) {
  var sessionId = _ref.sessionId;

  return _noAuthApiClient2.default.put(API_ENDPOINT, {
    query: {
      sessionId: sessionId,
      portalId: (0, _wrappedPortalIdParser2.default)('sendConsentToCommunicate client')
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./js/gdpr/client/ConsentToCommunicateClient.js
// module id = 521
// module chunks = 2 3